import { type MasterDataArticle, type Article } from '../apis/masterdata/masterdata.type';

export const enum LifeStage {
  creation = 0,
  active = 1,
  new = 2,
  deletionWithStockinCAC = 3,
  deletionWithoutStockAtAll = 4,
  archived = 5,
  deletionWithoutStockInCAC = 7,
  deletionWithoutStockInCAR = 8,
}

export const availableArticleLifeStages = [
  LifeStage.active,
  LifeStage.deletionWithStockinCAC,
  LifeStage.deletionWithoutStockInCAC,
  LifeStage.deletionWithoutStockInCAR,
];

export const iLinkLifeStages = [LifeStage.active, LifeStage.new, LifeStage.deletionWithStockinCAC, LifeStage.deletionWithoutStockInCAC];

export const emptyArticle = (): Article => ({
  articleId: 0,
  gridId: 0,
  labelGrid: '',
  selected: true,
  eanNum: '',
  pogoId: null,
});

export const findSelectedArticle = (article: Article | MasterDataArticle) => article.selected;

export const findArticleId = (articleId: number) => (article: { articleId: number }) => article.articleId === articleId;
